import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import IconFA from '../../../../components/icon/icon';
import { Link } from 'react-router-dom';
import Button from '../../../../components/button/button';
import { generatePDF } from "../../../../utils/generatePdf";
import EditInvoice from './editInvoice';
import { useInvoiceContext } from '../../../../utils/invoiceContext';
import '../components/invoice.component.css';
import Input from '../../../../components/input/input';

function InvoiceDetail() {
    const [edit, setEdit] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showInput, setShowInput] = useState(false);
    const [paymentDeadline, setPaymentDeadline] = useState(7);
    const [customDeadline, setCustomDeadline] = useState('');
    
    const { fetchOneInvoice, invoiceData, customerData, invoiceItems, handleDelete, handleSetPaid } = useInvoiceContext();

    let totalNet = 0;
    let totalBrut = 0;
    const { id } = useParams();

    useEffect(() => {
        fetchOneInvoice(id);
    }, [id]);

    return (
        <div className='invoiceContainer'>
            <div className='invoiceHeader'>
                <Link to='/dashboard/invoice'><IconFA iconName='arrowLeft' /></Link>
                <h1>Rechnung Nr.: { invoiceData.invoiceNumber }</h1>
            </div>

            {/* Kundendaten */}
            <div className='invoiceContentContainer'>
                <div className='invoiceHeadingContainer'><h3>Rechnungsdaten</h3></div>
                {!edit && (
                    <div>
                        <p>Rechnung von: {customerData.prename} {customerData.name}</p>
                        {invoiceData.actionDateTo ? (
                            <p>
                                Leistungszeitraum: {new Date(invoiceData.actionDate).getDate().toString().padStart(2, '0')}. 
                                {(new Date(invoiceData.actionDate).getMonth() + 1).toString().padStart(2, '0')}. 
                                {new Date(invoiceData.actionDate).getFullYear()} - {new Date(invoiceData.actionDateTo).getDate().toString().padStart(2, '0')}. 
                                {(new Date(invoiceData.actionDateTo).getMonth() + 1).toString().padStart(2, '0')}. 
                                {new Date(invoiceData.actionDateTo).getFullYear()}
                            </p>
                        ) : (
                            <p>
                                Leistungsdatum: {new Date(invoiceData.actionDate).getDate().toString().padStart(2, '0')}.
                                {(new Date(invoiceData.actionDate).getMonth() + 1).toString().padStart(2, '0')}.
                                {new Date(invoiceData.actionDate).getFullYear()}
                            </p>
                        )}
                        <p>
                            Rechnungsdatum: {new Date(invoiceData.invoiceDate).getDate().toString().padStart(2, '0')}.
                            {(new Date(invoiceData.invoiceDate).getMonth() + 1).toString().padStart(2, '0')}.
                            {new Date(invoiceData.invoiceDate).getFullYear()}
                        </p>
                    </div>
                )}
                {!edit && (
                    <div>
                    <p>Schon bezahlt: {invoiceData.isPaid ? 'Ja' : 'Nein'}</p>
                    {invoiceData.isPaid && <p>Zahlungsmethode: {invoiceData.paymentMethod || 'Nicht angegeben'}</p>}
                    <p>Rechnungsnummer: {invoiceData.invoiceNumber}</p>
                    <table className='createTable'>
                        <thead>
                            <tr>
                                <th className='createTh'>Position</th>
                                <th className='createTh'>Leistung</th>
                                <th className='createTh'>Einzelpreis<br />(Netto)</th>
                                <th className='createTh'>Anzahl</th>
                                <th className='createTh'>Gesamt<br/>(Pos.)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceItems.map((item) => (
                                <tr key={item.position}>
                                    <td className='createTd' data-label='Position'>{item.position}</td>
                                    <td className='createTd' id='createTdMobile'>
                                        <span>{item.item}</span>
                                        <span>{item.price} € x {item.count} Stück</span>
                                        <span><strong>{item.totalNet} €</strong></span>
                                    </td>
                                    <td className='createTd' data-label='Leistung'>{item.item}</td>
                                    <td className='createTd' data-label='Einzelpreis (Netto)'>{item.price}</td>
                                    <td className='createTd' data-label='Anzahl'>{item.count}</td>
                                    <td className='createTd' data-label='Gesamt (Pos.)'>{item.totalNet}</td>
                                </tr>
                            ))}
                            {(() => {
                                totalNet = invoiceItems.reduce((sum, item) => sum + (item.totalNet || 0), 0);
                                return (
                                    <tr>
                                        <td colSpan="6" className='createTd' style={{textAlign: 'right'}}>
                                            <strong>Gesamtpreis Netto: {totalNet.toFixed(2)} €</strong>
                                        </td>
                                    </tr>
                                );
                            })()}
                            {(() => {
                                totalBrut = invoiceItems.reduce((sum, item) => sum + (item.totalBrut || 0), 0);
                                return (
                                    <tr>
                                        <td colSpan="6" className='createTd' style={{textAlign: 'right'}}>
                                            <strong>Gesamtpreis Brutto: {totalBrut.toFixed(2)} €</strong>
                                        </td>
                                    </tr>
                                );
                            })()}
                        </tbody>
                    </table>
                    </div>
                )}
                {edit && (<EditInvoice onCancel={() => setEdit(false)} />)}
                {!edit && (
                    <>
                        <Button buttonValue="Bearbeiten" onClick={() => setEdit(!edit)} />
                        <Button buttonValue='Löschen' onClick={() => handleDelete(id)} />
                        <Button
                            buttonValue='Herunterladen'
                            onClick={() => {
                                // Überprüfe und formatiere das Datum
                                const actionDate = invoiceData.actionDate
                                    ? new Date(invoiceData.actionDate)
                                    : new Date(); // Standardwert: aktuelles Datum

                                const actionDateTo = invoiceData.actionDateTo
                                    ? new Date(invoiceData.actionDateTo)
                                    : null;

                                const invoiceDate = invoiceData.invoiceDate
                                    ? new Date(invoiceData.invoiceDate)
                                    : new Date(); // Standardwert: aktuelles Datum

                                if (!invoiceData.isPaid) {
                                    setShowModal(true);
                                } else {
                                    generatePDF(
                                        customerData.name || 'Unbekannt',
                                        customerData.prename || '',
                                        customerData.address || 'Unbekannte Adresse',
                                        customerData.postCode || '00000',
                                        customerData.town || 'Unbekannte Stadt',
                                        customerData.customerNumber || '0000',
                                        actionDate,
                                        actionDateTo,
                                        invoiceDate,
                                        invoiceData.invoiceNumber || 'Unbekannte Rechnungsnummer',
                                        invoiceData.paymentMethod || 'Unbekannte Zahlungsmethode',
                                        invoiceData.tax || 0,
                                        invoiceData.isPaid || false,
                                        7
                                    );
                                }
                            }}
                        />
                        {invoiceData.isPaid ? (
                            <Button
                                buttonValue="Buchung rückgängig machen"
                                onClick={() => handleSetPaid(false, id)}
                            />
                        ) : (
                            <Button
                                buttonValue="Rechnung als bezahlt markieren"
                                onClick={() => handleSetPaid(true, id)}
                            />
                        )}
                    </>
                )}
            </div>

            {showModal && (
                <div className="modal-overlay" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '8px',
                        maxWidth: '400px',
                        width: '90%'
                    }}>
                        {!showInput ? (
                            <>
                                <p>Rechnung ist nicht bezahlt, möchtest du eine Frist hinzufügen?</p>
                                <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                                    <Button buttonValue="Nein" onClick={() => {
                                        setShowModal(false);
                                        const actionDate = invoiceData.actionDate ? new Date(invoiceData.actionDate) : new Date();
                                        const actionDateTo = invoiceData.actionDateTo ? new Date(invoiceData.actionDateTo) : null;
                                        const invoiceDate = invoiceData.invoiceDate ? new Date(invoiceData.invoiceDate) : new Date();
                                        generatePDF(
                                            customerData.name || 'Unbekannt',
                                            customerData.prename || '',
                                            customerData.address || 'Unbekannte Adresse',
                                            customerData.postCode || '00000',
                                            customerData.town || 'Unbekannte Stadt',
                                            customerData.customerNumber || '0000',
                                            actionDate,
                                            actionDateTo,
                                            invoiceDate,
                                            invoiceData.invoiceNumber || 'Unbekannte Rechnungsnummer',
                                            invoiceData.paymentMethod || 'Unbekannte Zahlungsmethode',
                                            invoiceData.tax || 0,
                                            invoiceData.isPaid || false,
                                            0
                                        );
                                    }} />
                                    <Button buttonValue="Ja" onClick={() => setShowInput(true)} />
                                </div>
                            </>
                        ) : (
                            <>
                                <p>Frist in Tagen eingeben:</p>
                                <Input
                                    inputType="number"
                                    inputValue={customDeadline}
                                    onChange={(e) => setCustomDeadline(e.target.value)}
                                    placeholder="z.B. 14"
                                    width="100%"
                                />
                                <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                                    <Button buttonValue="Abbrechen" onClick={() => {
                                        setShowInput(false);
                                        setShowModal(false);
                                        setCustomDeadline('');
                                    }} />
                                    <Button buttonValue="Herunterladen" onClick={() => {
                                        const deadline = parseInt(customDeadline) || 7;
                                        setShowModal(false);
                                        setShowInput(false);
                                        const actionDate = invoiceData.actionDate ? new Date(invoiceData.actionDate) : new Date();
                                        const actionDateTo = invoiceData.actionDateTo ? new Date(invoiceData.actionDateTo) : null;
                                        const invoiceDate = invoiceData.invoiceDate ? new Date(invoiceData.invoiceDate) : new Date();
                                        generatePDF(
                                            customerData.name || 'Unbekannt',
                                            customerData.prename || '',
                                            customerData.address || 'Unbekannte Adresse',
                                            customerData.postCode || '00000',
                                            customerData.town || 'Unbekannte Stadt',
                                            customerData.customerNumber || '0000',
                                            actionDate,
                                            actionDateTo,
                                            invoiceDate,
                                            invoiceData.invoiceNumber || 'Unbekannte Rechnungsnummer',
                                            invoiceData.paymentMethod || 'Unbekannte Zahlungsmethode',
                                            invoiceData.tax || 0,
                                            invoiceData.isPaid || false,
                                            deadline
                                        );
                                        setCustomDeadline('');
                                    }} />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default InvoiceDetail;